import {ButtonGroup} from 'platform/components';
import {Box, VStack} from 'platform/foundation';

import {isNil} from 'ramda';

import {useGetRentalOrderQuery} from '@dms/api/rental';
import i18n from '@dms/i18n';
import {rentalOrderRoutes, testIds} from '@dms/routes';
import {Main} from '@dms/shared';

import {composePath, useNavigate, useRequiredParams} from 'shared/web';

import {ReturnInspections} from '../Inspections/ReturnInspections';
import {ReturnVehicleForm} from '../ReturnVehicleForm/ReturnVehicleForm';
import {VehicleRentalDocuments} from '../VehicleRentalDocuments/VehicleRentalDocuments';
import {useReturnInspectionActions} from './hooks/useReturnInspectionActions';

export function ReturnVehicle() {
  const {id: rentalOrderId} = useRequiredParams();
  const {data: rentalOrder} = useGetRentalOrderQuery({rentalOrderId});

  const navigate = useNavigate();
  const actions = useReturnInspectionActions();

  return (
    <VStack width="100%">
      <Main
        actions={actions}
        tabs={[
          {
            href: composePath(rentalOrderRoutes.returnVehicle, {params: {id: rentalOrderId}}),
            content: (
              <VStack spacing={4}>
                <ReturnVehicleForm />
                <VehicleRentalDocuments />
              </VStack>
            ),
            id: 'return-vehicle-form',
            title: i18n.t('general.labels.basicInformation'),
            'data-testid': testIds.rentalOrder.returnVehicle('navigation-rentVehicle'),
          },
          {
            href: composePath(rentalOrderRoutes.returnVehicleInspections, {
              params: {id: rentalOrderId},
            }),
            content: <ReturnInspections />,
            isDisabled: isNil(rentalOrder?.rentalVehicleId),
            id: 'return-vehicle-inspections',
            title: i18n.t('entity.vehicle.labels.inspections'),
            'data-testid': testIds.rentalOrder.returnVehicle('navigation-inspections'),
          },
        ]}
      />

      <Box padding={[2, 4]}>
        <ButtonGroup
          align="right"
          buttons={[
            {
              variant: 'outlined',
              title: i18n.t('general.actions.back'),
              'data-testid': testIds.rentalOrder.returnVehicle('backButton'),
              onClick: () =>
                navigate(composePath(rentalOrderRoutes.rentVehicle, {params: {id: rentalOrderId}})),
            },
          ]}
        />
      </Box>
    </VStack>
  );
}
